export default __webpack_public_path__ + "static/media/clinic.7abf121d.png";